import React from "react";
import { Navbar, Footer, CookieConsentBanner } from "@DR/components/views";
import { Footer as ApplyFooter } from "@DR/components/views/pages/Apply";

const Layout = ({
  address,
  children,
  isApplyPage = false,
  is404Page = false,
  showLinks = true,
  phoneNumber,
}) => {
  return (
    <React.Fragment>
      <CookieConsentBanner />
      <main className="relative font-avenir w-full h-full pt-[85px] lg:pt-32 desktop:pt-[150px] overflow-x-hidden">
        <Navbar
          isApplyPage={isApplyPage}
          is404Page={is404Page}
          showLinks={showLinks}
          phoneNumber={phoneNumber}
        />
        {children}
        {isApplyPage ? (
          <ApplyFooter phoneNumber={phoneNumber} />
        ) : (
          <Footer address={address} phoneNumber={phoneNumber} />
        )}
      </main>
    </React.Fragment>
  );
};

export default Layout;
